/**
 * @file inputSanitizer.js
 * @description Automatically intercepts user input on text fields and textareas to remove any emojis.
 * * @note This sanitizer is intentionally NOT applied to password inputs (`input[type="password"]`)
 * Executes immediately upon being required or bundled.
 * @requires jQuery
 */

'use strict';

/**
 * Event listener hooked into the document input event.
 * Targets standard text inputs and textareas to sanitize emoji characters.
 * * @name inputEmojiSanitizer
 * @inner
 * @param {jQuery.Event} event - The jQuery input event object.
 */
$(document).on('input', 'input[type="text"], input[type="search"], input[type="email"], textarea', function () {
    const emojiRegex = /\p{Emoji_Presentation}|\p{Extended_Pictographic}/gu;
    
    const originalValue = this.value;

    if (emojiRegex.test(originalValue)) {
        emojiRegex.lastIndex = 0; 
        
        const cleanedValue = originalValue.replace(emojiRegex, '');
        
        const removedEmojis = originalValue.match(emojiRegex);

        //console.log(`[Input Sanitizer] Blocked input: "${removedEmojis ? removedEmojis.join(', ') : ''}" removed from field.`);
        
        this.value = cleanedValue;
    }
});

module.exports = {};